<table class="table table-hover product-results">
	<thead>
		<tr>
			<th class="sticky text-dark shrink"></th>
			<th class="sticky text-dark">Image</th>
			<th class="sticky text-dark">Product</th>
			<th class="sticky text-dark">Distributor</th>
			<th class="sticky text-dark">Price</th>
			<th class="sticky text-dark text-center">Distributor Stock</th>
			<th class="sticky text-dark shrink nowrap"></th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of items | pagination:pagination" [ngClass]="{ 'table-success': isRowAdded(item), 'has-extras': hasExtras(item) }">
			<td class="shrink h2 align-middle">
				<i *ngIf="item.distributors.length > 1" class="wq selectable p-2" (click)="toggleExpanded(item)" [ngClass]="{'wq-caret-right': !isExpanded(item), 'wq-caret-down': isExpanded(item)}"></i>
			</td>
			<td class="shrink pr-0 align-middle">
				<div *ngIf="item.image_url" class="product-image mr-3" [style.backgroundImage]="'url(\'' + item.image_url + '\')' | safeStyle"></div>
			</td>
			<!-- Nothing in this cell opens the panel: the SKU and the model are here to be read and copied, and a
			     cell-wide click target made selecting the text impossible. The panel has its own link below. -->
			<td class="pl-0 align-middle" style="max-width: 31rem;">
				<div *ngIf="item.short_description" class="text-bold mb-1" [innerHTML]="item.short_description | highlight: query | safeHtml"></div>
				<!-- A span each, rather than one concatenation: a missing manufacturer or model stringified to "null". -->
				<div *ngIf="item.manufacturer_name || item.model" class="text-secondary mb-1">
					<span *ngIf="item.manufacturer_name" [innerHTML]="item.manufacturer_name | highlight: query | safeHtml"></span>
					<span *ngIf="item.manufacturer_name && item.model"> / </span>
					<span *ngIf="item.model" [innerHTML]="item.model | highlight: query | safeHtml"></span>
				</div>
				<div *ngIf="item.sku || item.manufacturer_sku" class="text-secondary text-tiny mb-1" [innerHTML]="(item.sku || item.manufacturer_sku) | highlight: query | safeHtml"></div>
				<!-- Every copy dropped reads as a dead product; some of them is a note about which supplier to pick. -->
				<span *ngIf="allDiscontinued(item)" class="badge badge-danger text-tiny">Discontinued</span>
				<!-- <span *ngIf="someDiscontinued(item)" class="badge badge-danger text-tiny">{{item.discontinued_count}}/{{item.distributor_count}} discontinued</span> -->

				<!-- The only way into the product panel, so the rest of the row stays selectable text. -->
				<div *ngIf="canOpenDetail" class="mt-1">
					<div style="font-size: 0.55rem;" class="btn btn-sm btn-outline-info border-0 p-1" (click)="selectProduct(item.id)"><i class="wq wq-info mr-1"></i>More info</div>
				</div>
			</td>

			<ng-container *ngIf="!isExpanded(item); else showExpandedList">
				<td class="text-small align-middle">
					<div class="d-flex align-items-center">
						<ui-avatar-stack [items]="item.distributors" [max]="3" fallbackName="My Products"
							[ngClass]="{ 'mr-2': item.distributors?.length === 1, 'selectable': item.distributors?.length > 1 }"
							(click)="item.distributors?.length > 1 && toggleExpanded(item)"></ui-avatar-stack>
						<div *ngIf="item.distributors?.length === 1"
							[ngClass]="{ 'selectable': canEditProduct }"
							(click)="openEditProduct(item.distributors[0], $event)">
							<!-- The tooltip hangs off the name rather than the block around it, so it sits against the
							     text it is about instead of floating over the row above. -->
							<div class="nowrap d-inline-block" [ngbTooltip]="canEditProduct ? 'Edit product' : ''" placement="top">{{item.distributors[0].name || 'My Products'}}</div>
							<ng-container *ngTemplateOutlet="extrasCount; context: { distributor: item.distributors[0] }"></ng-container>
						</div>
					</div>
				</td>
				<td class="align-middle">
					<ng-container *ngTemplateOutlet="price; context: { distributor: item.distributors[0] }"></ng-container>
				</td>
				<td class="align-middle">
					<div class="badge d-block text-tiny px-3" [ngClass]="stockClass(item.distributors[0]?.stock)">{{stockKnown(item.distributors[0]?.stock) ? (item.distributors[0]?.stock | decimal:0) : 'N/A'}}</div>
				</td>
				<td class="shrink nowrap align-middle">
					<!-- With more than one copy behind the row there is nothing to add until one of them is named. -->
					<div *ngIf="item.distributors?.length === 1 && canAdd && item.distributors[0]?.can_add !== false" class="d-flex align-items-center justify-content-end">
						<ng-container *ngTemplateOutlet="addButton; context: { distributor: item.distributors[0] }"></ng-container>
					</div>
				</td>
			</ng-container>

			<ng-template #showExpandedList>
				<td class="text-small">
					<div *ngFor="let distributor of item.distributors" class="d-flex align-items-center distributor-row"
						[ngClass]="{ 'selectable': canEditProduct }"
						(click)="openEditProduct(distributor, $event)">
						<ui-avatar-stack [items]="[distributor]" [max]="1" class="mr-2" fallbackName="My Products"></ui-avatar-stack>
						<div>
							<div class="d-flex align-items-center">
								<!-- The tooltip hangs off the name rather than the row, so it sits against the text it is
								     about instead of floating over the row above. -->
								<span class="nowrap" [ngbTooltip]="canEditProduct ? 'Edit product' : ''" placement="top">{{distributor.name || 'My Products'}}</span>
								<span *ngIf="distributor.discontinued" class="badge badge-danger text-tiny ml-2 nowrap">Discontinued</span>
							</div>
							<ng-container *ngTemplateOutlet="extrasCount; context: { distributor: distributor }"></ng-container>
						</div>
					</div>
				</td>
				<td class="text-small">
					<div *ngFor="let distributor of item.distributors" class="distributor-row d-flex align-items-center">
						<ng-container *ngTemplateOutlet="price; context: { distributor: distributor }"></ng-container>
					</div>
				</td>
				<td>
					<div *ngFor="let distributor of item.distributors" class="distributor-row d-flex align-items-center">
						<span class="badge d-block text-tiny px-3 w-100" [ngClass]="stockClass(distributor.stock)">{{stockKnown(distributor.stock) ? (distributor.stock | decimal:0) : 'N/A'}}</span>
					</div>
				</td>
				<td class="shrink nowrap">
					<ng-container *ngIf="canAdd">
						<!-- The row itself stays whether or not it can be added, so the copies keep lining up with
						     their prices and stock levels in the columns beside them. -->
						<div *ngFor="let distributor of item.distributors" class="distributor-row d-flex align-items-center justify-content-end">
							<ng-container *ngIf="distributor.can_add !== false">
								<ng-container *ngTemplateOutlet="addButton; context: { distributor: distributor }"></ng-container>
							</ng-container>
						</div>
					</ng-container>
				</td>
			</ng-template>
		</tr>
		<tr *ngIf="!pagination?.count">
			<td colspan="7" class="text-secondary">{{emptyText}}</td>
		</tr>
	</tbody>
</table>

<!-- A bundle's stored price is zero until its options are picked, so it says so rather than reading as free. -->
<ng-template #price let-distributor="distributor">
	<span *ngIf="distributor?.is_bundle; else sellPrice" class="badge bg-purple-15 text-purple text-tiny nowrap"><i class="wq wq-configure mr-1"></i> Configure for price</span>
	<ng-template #sellPrice><div class="text-small">{{distributor?.sell_price | currencyFlexible:distributor?.currency_id}}</div></ng-template>
</ng-template>

<!-- What the copy carries with it, in the colours the product list uses for the same two counts: accessories green,
     labour purple. A line of its own under the supplier's name. -->
<ng-template #extrasCount let-distributor="distributor">
	<div *ngIf="distributor?.accessories_count || distributor?.labour_count" class="d-flex align-items-center">
		<span *ngIf="distributor.accessories_count" class="text-success text-bold text-tiny nowrap mr-2">{{distributor.accessories_count}} {{distributor.accessories_count === 1 ? 'accessory' : 'accessories'}}</span>
		<span *ngIf="distributor.labour_count" class="text-purple text-bold text-tiny nowrap">{{distributor.labour_count}} labour</span>
	</div>
</ng-template>

<!-- Adding a copy that is already in ticks it and takes it back out again, so the button is its own undo. -->
<ng-template #addButton let-distributor="distributor">
	<!-- The count where the caller keeps one, the same circle the picker's own product list puts against a row. -->
	<span *ngIf="addedQuantity(distributor)" class="badge badge-success rounded-circle added-count mr-2">{{addedQuantity(distributor)}}</span>
	<i *ngIf="isAdded(distributor) && !addedQuantity(distributor)" class="wq wq-check text-success mr-2"></i>
	<button type="button" class="btn btn-sm add-btn text-tiny" [ngClass]="isAdded(distributor) ? 'btn-outline-success' : 'btn-secondary'" (click)="addDistributor(distributor)">{{isAdded(distributor) ? addedLabel : addLabel}}</button>
</ng-template>
